import Image from 'next/image';
import ImageWithFallback from '@/src/features/ui/image/image-with-fallback';

interface SkeletonLoaderProps {
  type?: 'text' | 'image';
  className: string;
}

export const SkeletonLoader = ({ type = 'text', className }: SkeletonLoaderProps) => {
  const createLoader = () => {
    if (type === 'image') {
      return (
        <div className={`flex ${className} w-full items-center justify-center rounded bg-gray-200 p-2`}>
          <ImageWithFallback src="/assets/recourse/loading.svg" width={15} height={17} alt="hangikredi loading" />
        </div>
      );
    } else return <div className={`${className} rounded-md bg-gray-200`}></div>;
  };

  return (
    <output className="max-w-sm animate-pulse">
      {createLoader()}
      <span className="sr-only">Loading...</span>
    </output>
  );
};
